<template lang="pug">
GenericCard(:size='size' unit="%")
  //- button.transparent-button.pp-stat-item.d-flex.align-items-center.w-100.p-3(
  .pp-stat-item.d-flex.align-items-center.w-100.p-3(
    @click='$emit(`click`)'
  )
    //- :class='highlighted ? `highlighted`:``'
    template(v-if='iconSrc')
      img(:src='iconSrc' width='56' height='56')
    .d-flex.flex-column.align-items-end.ml-auto
      .value(:style='valueStyle')
        | {{ value | currency }}
      .key {{ title }}
</template>

<script>
export default {
  props: {
    badgeNumber: {
      default: -1,
    },
    title: {
      default: '...',
    },
    value: {
      default: -1,
    },

    color: {
      default: '#303030',
    },

    size: {
      default: '36',
    },


    iconSrc: {
      default: '',
    },
  },
  computed: {
    valueStyle() {
      return `color: ${this.color};`;
    },
  },
};
</script>

<style lang="scss">
.pp-stat-item {
  border-radius: $card-border-radius;
  // .amount {
  //   display: flex;
  //   align-items: center;
  //   justify-content: center;
  //   height: 64px;
  //   width: 64px;
  //   background: #0092C9;

  //   font-size: 32px;
  //   color: #fff;
  // }
  .key {
    font-size: 14px;
    color: #6B6C6F;

    letter-spacing: 1px;
  }
  .value {
    // color: #303030;
    font-size: 30px;

    margin-top: -6px;
    letter-spacing: 3px;
    font-weight: 500;
  }

  // &.highlighted {
  //   background: linear-gradient(to right, #0B478B, #1C87AE);

  //   .amount {
  //     background: #fff;
  //     color: #134D8B;
  //   }
  //   .key {
  //     color: #fff;
  //     font-weight: 300;
  //   }
  //   .value {
  //     color: #fff;
  //     font-weight: 300;
  //   }
  // }
}
</style>
